import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';


const Error404Page = () => {
    return (
        <Fragment>
                <div className="container-fluid px-lg-1 px-xl-3">
                    <div className="page-breadcrumb">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <NavLink to="/home">Principal</NavLink>
                            </li>
                            <li className="breadcrumb-item">
                                <NavLink to="/home">Error 404</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="page-header">
                        <h1 className="page-heading">Error 404</h1>
                    </div>
                    <section>
                        <div className="card mb-4">
                            <div className="card-header">
                                <div className="card-heading">Error 404</div>
                            </div>
                            <div className="card-body text-muted">
                                
                            </div>
                        </div>                        
                    </section>
                </div>
        </Fragment>
    );
}

export default Error404Page;
